import React from "react";

import {
    getDataFromResponse,
    getDataWithPromise,
    getNumRowsFromResponse,
    Globals,
} from '../../DataFunctions/BaseDataFns';

export const groupStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: 'green',
    fontStyle: 'bold',
    fontSize: 'large'
};

export const groupBadgeStyles = {
    backgroundColor: '#EBECF0',
    borderRadius: '2em',
    display: 'inline-block',
    fontWeight: 'normal',
    lineHeight: '1',
    minWidth: 1,
    padding: '0.16666666666667em 0.5em',
    textAlign: 'center',
    color: 'green',
    fontStyle: 'bold',
    fontSize: 'large'
};

export const formatGroupLabel = data => (
    <div style={groupStyles}>
        <span>{data.label}</span>
        <span style={groupBadgeStyles}>{data.options.length}</span>
    </div>
);

const genericListboxFetch = ( url, id_field_name, text_field_name) =>
{
    return new Promise((resolve, reject) =>
    {
        if (url == null || url == '')
        {
            throw Error('getDataWithPromise cannot call an empty URL');
        }
        else
        {
            getDataWithPromise(url, 'GET', {}).then(response =>
            {
                const rows = getNumRowsFromResponse(response) > 0 ? getDataFromResponse(response) : [];

                // Map the data into the format the listbox wants.
                // Each listbox will map the value and label elements from the returned listbox data
                resolve ( rows.map((entry) => {
                    return { value: entry[id_field_name], label: entry[text_field_name]}
                })) ;
            })
            .catch((jqXHR, textStatus, error) =>
            {
                reject(jqXHR, textStatus, error);
            });
        }
    });
}

export const getFamilyTypes = () =>
{
    const url = Globals.APIFolder + '/family/familyTypes' ;

    return genericListboxFetch( url, 'type_id', 'type_name') ;
}

export const getSchoolTermData = ( ) =>
{
    const url = Globals.APIFolder + '/terms' ;

    return genericListboxFetch( url, 'year_term_id', 'friendly_name') ;
}

export const getYesNoData = ( dataType ) =>
{
    let options = [] ;

    if ( dataType === 'int')
    {
        options =
            [
                { value: 1, label: 'Yes'},
                { value: 0, label: 'No'},
            ];
    }
    else
    {
        options =
            [
                { value: 'Y', label: 'Yes'},
                { value: 'N', label: 'No'},
            ];
    }

    return new Promise((resolve, reject) =>
    {
        resolve(options);
    });
}

export const getSchoolYearData = ( includeEarly ) =>
{
    let years = [] ;

    if ( includeEarly === true )
    {
        years = [
            { value: 14, label: 'Reception'},
            { value: 15, label: 'Nursery'},
            { value: 1, label: 'Year 1'},
            { value: 2, label: 'Year 2'},
            { value: 3, label: 'Year 3'},
            { value: 4, label: 'Year 4'},
            { value: 5, label: 'Year 5'},
            { value: 6, label: 'Year 6'},
            { value: 7, label: 'Year 7'},
            { value: 8, label: 'Year 8'},
            { value: 9, label: 'Year 9'},
            { value: 10, label: 'Year 10'},
            { value: 11, label: 'Year 11'},
            { value: 12, label: 'Year 12'}];
    }
    else
    {
        years = [
            { value: 1, label: 'Year 1'},
            { value: 2, label: 'Year 2'},
            { value: 3, label: 'Year 3'},
            { value: 4, label: 'Year 4'},
            { value: 5, label: 'Year 5'},
            { value: 6, label: 'Year 6'},
            { value: 7, label: 'Year 7'},
            { value: 8, label: 'Year 8'},
            { value: 9, label: 'Year 9'},
            { value: 10, label: 'Year 10'},
            { value: 11, label: 'Year 11'},
            { value: 12, label: 'Year 12'}];
    }

    return new Promise((resolve, reject) =>
    {
        resolve(years);
    });
}

export const getContractTypes = ()  =>
{
     const contractTypes =
         [
            { value: 1, label: 'Face to Face Communication'},
            { value: 2, label: 'Face to Face Communication, Supervised'},
            { value: 3, label: 'Supervised Telephone Communication'},
            { value: 4, label: 'Settling in letter'},
            { value: 5, label: 'Messaging'}

        ]
    return new Promise((resolve, reject) =>
    {
        resolve(contractTypes);
    });

    }

export const getSiblingsData = ()  =>
{
    const url = Globals.APIFolder + '/family/relationtypes?siblingTypes' ;

    return genericListboxFetch( url, 'ar_type_id', 'name') ;
}

export const getRelationshipData = ()  =>
{
    const url = Globals.APIFolder + '/familyMember/relationTypes' ;

    return genericListboxFetch( url, 'ar_type_id', 'name') ;
}

export const getContactApproved = ()  =>
{
    const url = Globals.APIFolder + '/child/child_id/sibling';

    return genericListboxFetch( url, 'child_id', '0') ;

}

export const getChildStatusData = ()  =>
{
    const url = Globals.APIFolder + '/child/listAllCareStatuses' ;

    return genericListboxFetch( url, 'acs_id', 'acs_status') ;
}

/*export const getUsersCanConnect = (user_id, mode)  =>
{
    const url = Globals.APIFolder + '/users/'+ user_id + '/usersCanConnect?mode=' + mode ;

    return genericListboxFetch( url, 'idusers', 'fullNameAndType') ;
}*/

export const getDocumentTypes = () =>
{
    const url = Globals.APIFolder + '/document/documentTypes' ;

    return genericListboxFetch( url, 'document_type_id', 'document_type') ;
}

export const getLetterboxusers = () =>
{
    const url = Globals.APIFolder + '/users/letterbox' ;

    return genericListboxFetch( url, 'idusers', 'fullNameAndType') ;
}

export const getLetterboxDecisions = () =>
{
    const url = Globals.APIFolder + '/letterbox/decisions' ;

    return genericListboxFetch( url, 'letterbox_decision_type_id', 'letterbox_decision_type') ;
}

export const getResourceTypes = () =>
{
    const url = Globals.APIFolder + '/resources/types' ;

    return genericListboxFetch( url, 'rt_id', 'rt_name') ;
}

export const getTeams = () =>
{
    const url = Globals.APIFolder + '/organisation/current/teams' ;

    return genericListboxFetch( url, 'unenc_team_id', 'team_name') ;
}

export const getUserTypes = () =>
{
    const url = Globals.APIFolder + '/users/types?adults=true' ;

    return genericListboxFetch( url, 'team_id', 'team_name') ;
}
